import { ImageProps } from "@chakra-ui/react";
import { EmptyPhotoIcon } from "../../../svg";
import { Container } from "./EmptyPicker.styles";

export const EmptyPicker = ({ onClick }: ImageProps) => (
  <Container onClick={onClick}>
    <EmptyPhotoIcon />
  </Container>
);
